import React from "react";
import StartApplication from "../../components/templates/home/Apply/StartApplication";
import OptionsSection from "../../components/templates/home/Apply/OptionsSection";
import AboutUs from "../../components/templates/home/Apply/Aboutus";
import CustomerSection from "../../components/templates/home/Apply/CustomerPortal";

const Apply = () => {
  return (
    <div>
      <StartApplication />
      <OptionsSection />
      <AboutUs />
      <CustomerSection />
    </div>
  );
};

export default Apply;
